import {
    GET_FIRMWARE,
    GET_FIRMWARE_SUCCESS,
    GET_FIRMWARE_FAIL,
    GET_SWITCH_FIRMWARE_SUCCESS,
    GET_SWITCH_FIRMWARE,
    GET_SWITCH_FIRMWARE_FAIL,
    FIRMWARE_NAVIGATION_TRIGGERED,
} from '../../constants/firmwareManagementConstants/firmwareConstants';
import { DEVICE_FILTER_LIST_GET_FAIL, DEVICE_FILTER_LIST_GET_SUCCESS, GET_DEVICE_FILTER_LIST } from '../../constants/firmwareManagementConstants/managementConstants';

/**
 * Reducer function for managing firmware management list state.
 *
 * This reducer handles actions related to fetching firmware management data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the firmware management list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const firmwareListReducer = (state = { firmware: {} }, action) => {
    switch (action.type) {
        case GET_FIRMWARE:
            return {
                loading: true,
            };
        case GET_FIRMWARE_SUCCESS:
            return {
                loading: false,
                firmware: action.payload,
            };
        case GET_FIRMWARE_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export const switchFirmwareListReducer = (state = { switchFirmware: {} }, action) => {
    switch (action.type) {
        case GET_SWITCH_FIRMWARE:
            return {
                loading: true,
            };
        case GET_SWITCH_FIRMWARE_SUCCESS:
            return {
                loading: false,
                switchFirmware: action.payload,
            };
        case GET_SWITCH_FIRMWARE_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export const firmwareNavigatiorReducer = (state = { firmwareNavigationTriggered: false }, action) => {
    switch (action.type) {
        case FIRMWARE_NAVIGATION_TRIGGERED:
            return {
                ...state,
                firmwareNavigationTriggered: action.payload
            };
        default:
            return state;
    }
};

export const deviceListReducer = (
    state = {
        loading: false,
        devicesList: [],
        totalCount: null,
    },
    action
) => {
    switch (action.type) {
        case GET_DEVICE_FILTER_LIST:
            return { ...state, loading: true };
        case DEVICE_FILTER_LIST_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                devicesList: action.payload.results,
                totalCount: action.payload.count,
            };
        case DEVICE_FILTER_LIST_GET_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

